import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ForgetComponent, SSOComponent} from './containers';
import {LoginComponent} from './containers/login/login.component';
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'sso/redirect',
        component: SSOComponent
      },
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'auth/forget',
        component: ForgetComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
